import React from 'react';
import styles from './contact-item.module.scss';
import { ContactsEntityIcon, PagerIcon } from '../../images';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { FavoritesButton } from '../favorites-button/favorites-button';
import { FAVORITES_ENTITIES, ROUTES, CATEGORY_TYPES } from 'shared/constants';
import { ShareBoxComponent } from '../../components/share';
import { MailFilled, PhoneFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { formatContactSubtitle, formatFullName } from 'shared/utils';
import { LabelsList } from '../labels';
import { Tooltip } from '../core/tooltip/tooltip.component';

const ContactItemComponent = React.memo(function ContactItemComponent({
  contact,
  onClickEvent = () => {},
  hideFavorites = false,
}) {
  const tagsLang = useSelector(getLang('TAGS'));
  const profileOptionsLang = useSelector(getLang('PROFILE_OPTIONS'));
  const lang = useSelector(getLang('CONTACT_SCREEN'));
  const contactPath = ROUTES.CONTACTS_PREVIEW.replace(':id', contact.id);

  const navigateToContact = () => {
    const event = {
      id: contact.id,
      title: contact?.firstName,
    };
    onClickEvent(event);
  };

  const openMailto = e => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = `mailto:${contact.email}`;
  };

  const renderSecondaryDetail = () => {
    if (contact?.pager) {
      return (
        <div className={styles.iconWrapper}>
          <PagerIcon className={styles.pagerIcon} />
          <div className={styles.pager}>{contact?.pager}</div>
        </div>
      );
    }

    if (contact?.email) {
      return (
        <div className={styles.iconWrapper}>
          <MailFilled className={styles.icon} />
          <div className={styles.email}>
            {contact?.email && (
              <Tooltip title={lang.SEND_EMAIL}>
                <span
                  role="link"
                  tabIndex={0}
                  onClick={openMailto}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') openMailto(e);
                  }}>
                  {contact.email}
                </span>
              </Tooltip>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <Link to={contactPath} className={styles.root} onClick={navigateToContact}>
      <div className={styles.thumbnailWrapper}>
        <img src={ContactsEntityIcon} alt={'contact'} />
      </div>
      <div className={styles.content}>
        <div className={styles.wrapper}>
          <div className={styles.name}>
            {formatFullName(contact, {
              labelInParenthesis: contact?.isDeactivated ? lang.DEACTIVATED : null,
            })}
          </div>
          <div className={styles.department}>
            {formatContactSubtitle(contact, { tagsLang, profileOptionsLang })}
          </div>
        </div>
        <div className={styles.contacts}>
          {contact?.phone && (
            <div className={styles.iconWrapper}>
              <PhoneFilled className={styles.icon} />
              <div className={styles.phone}>{contact?.phone}</div>
            </div>
          )}
          {renderSecondaryDetail()}
        </div>
        <div className={styles.labelsContainer}>
          {contact?.professional?.location && (
            <LabelsList labels={contact?.professional?.location} />
          )}
        </div>
        <div className={styles.actionIcons}>
          <button type="button" tabIndex={-1} className={styles.buttonWrapper}>
            <ShareBoxComponent
              path={contactPath}
              id={contact.id}
              title={contact?.firstName}
              entityType={CATEGORY_TYPES.KNOWLEDGE}
              iconClassName={styles.actionIcon}
            />
          </button>
          {!hideFavorites && (
            <FavoritesButton
              id={contact.id}
              entity={contact.isUser ? FAVORITES_ENTITIES.USER : FAVORITES_ENTITIES.CONTACT}
              background={styles.greyBackground}
              className={styles.actionIcon}
            />
          )}
        </div>
      </div>
    </Link>
  );
});

export { ContactItemComponent };
